import Subtitle from 'src/components/typography/Subtitle'
import styled from 'styled-components'
import tw from 'twin.macro'

const StyledSubtitleColorOverwrite = styled(Subtitle)`
  ${tw`text-almostBlackBlue border-almostBlackBlue`}
`

export default StyledSubtitleColorOverwrite
